import { randomInteger } from "@evergis/ui";

import { useConfigSettings } from "../useConfigSettings";

import { PortalConfiguration } from "../../ducks/portalConfig";

export const useLoginScreenSettings = (): PortalConfiguration["settings"]["loginScreen"] => {
  const { loginScreen } = useConfigSettings();
  const currentScreen = loginScreen?.[randomInteger(0, loginScreen.length - 1)];

  return {
    ...currentScreen,
    footer: {
      ...currentScreen?.footer,
      logo: currentScreen?.footer?.logo,
    },
    hasContent:
      !!currentScreen?.logo?.img ||
      !!currentScreen?.logo?.text ||
      !!currentScreen?.title?.text ||
      !!currentScreen?.description?.text ||
      !!currentScreen?.footer?.logo ||
      !!currentScreen?.footer?.networks?.length ||
      !!currentScreen?.footer?.links?.length,
    title: {
      ...currentScreen?.title,
      text: currentScreen?.title?.text,
    },
    description: {
      ...currentScreen?.description,
      text: currentScreen?.description?.text,
    },
  };
};
